import { http } from 'services/http';
import type { CargoItemRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteCargoItemsVariables {
  cargoId: number;
}

export const useDeleteCargo = () => {
  return useMutationBase<CargoItemRes, unknown, IDeleteCargoItemsVariables>({
    mutationFn: async ({ cargoId }) => {
      const res = await http.delete<CargoItemRes>(`/v1/cargo/${cargoId}`);

      return res.data;
    },
  });
};
